export default {
  images: [],
  image: {}
}